webpackJsonp([280106851839584],{

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(45);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _styles = __webpack_require__(11);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _banner = __webpack_require__(67);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _inline = __webpack_require__(139);
	
	var _inline2 = _interopRequireDefault(_inline);
	
	var _styles2 = __webpack_require__(610);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThingContent = function ThingContent(_ref) {
	  var thing = _ref.thing,
	      metadata = _ref.metadata,
	      classes = _ref.classes;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_banner2.default, {
	      uid: 'thing_' + thing.type.toLowerCase(),
	      title: thing.title,
	      subtitle: thing.subtitle
	    }),
	    _react2.default.createElement(Intro, { thing: thing }),
	    thing.contents && _react2.default.createElement(Contents, { thing: thing }),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	var Intro = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      thing = props.thing;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.thing },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 0 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'subheading' },
	                thing.subtitle.text
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display1', className: classes.title },
	                _react2.default.createElement(_gradient2.default, {
	                  text: thing.title.text,
	                  fromColor: '#333',
	                  toColor: '#999',
	                  direction: 'left'
	                })
	              )
	            ),
	            _react2.default.createElement('div', {
	              dangerouslySetInnerHTML: {
	                __html: thing.intro && thing.intro.html
	              },
	              className: classes.text
	            })
	          )
	        )
	      )
	    )
	  );
	});
	
	var Contents = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      thing = props.thing;
	
	  return thing.contents.map(function (content, i) {
	    if (content == null) {
	      // FIXME: Optional chaining?
	      return;
	    }
	    switch (content.type) {
	      case 'PrismicCtThingBodyVideo':
	        return _react2.default.createElement(VideoBlock, { key: i, content: content });
	      case 'PrismicCtThingBodyBlock':
	        return _react2.default.createElement(ContentBlock, { key: i, content: content });
	      case 'PrismicCtThingBodyQuote':
	        return _react2.default.createElement(_quote2.default, {
	          key: i,
	          quote: {
	            author: content.primary.author,
	            quote: content.primary.quote
	          }
	        });
	        break;
	      case 'PrismicCtThingBodyEyecandy':
	        return _react2.default.createElement(Candy, { key: i, content: content });
	        break;
	      case 'PrismicCtThingBodyTakeaways':
	        return _react2.default.createElement(Takeaway, { key: i, content: content });
	        break;
	      default:
	        break;
	    }
	  });
	});
	
	var VideoBlock = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var content = props.content,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.thing },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(_inline2.default, {
	            urls: content.primary.video_data.urls,
	            poster: content.primary.video_data.poster
	          })
	        )
	      )
	    )
	  );
	});
	
	var ContentBlock = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var content = props.content,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.thing },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          content.items.map(function (item, i) {
	            return _react2.default.createElement(
	              _Grid2.default,
	              { key: i, container: true, spacing: 0, style: { marginBottom: '20px' } },
	              _react2.default.createElement(
	                _Grid2.default,
	                { item: true },
	                _react2.default.createElement(
	                  _Typography2.default,
	                  { variant: 'display1', className: classes.title },
	                  item.block_title && _react2.default.createElement(_gradient2.default, {
	                    text: item.block_title.text,
	                    fromColor: '#333',
	                    toColor: '#999',
	                    direction: 'left'
	                  })
	                ),
	                _react2.default.createElement('div', {
	                  dangerouslySetInnerHTML: {
	                    __html: item.block_text && item.block_text.html
	                  },
	                  className: classes.text,
	                  style: { flex: 1 }
	                })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	});
	
	var Candy = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var content = props.content,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.thingCandy },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 0 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true },
	              _react2.default.createElement(
	                _Typography2.default,
	                { variant: 'display1', className: classes.candyTitle },
	                _react2.default.createElement(_gradient2.default, {
	                  text: content.primary.eyecandy_title.text,
	                  fromColor: '#333',
	                  toColor: '#999',
	                  direction: 'left'
	                })
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { className: classes.candyText },
	                content.primary.eyecandy_text.text
	              )
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              { container: true, spacing: 40 },
	              content.items.map(function (item, index) {
	                return _react2.default.createElement(
	                  _Grid2.default,
	                  { key: index, item: true, xs: 12, sm: 4 },
	                  _react2.default.createElement(_gatsbyImage2.default, { sizes: item.candy_image.sizes })
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	var Takeaway = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var content = props.content,
	      classes = props.classes;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'servicesA' },
	    _react2.default.createElement(
	      'div',
	      { className: classes.thingTakeaway },
	      _react2.default.createElement(
	        'div',
	        { className: classes.contents },
	        _react2.default.createElement(
	          'div',
	          { className: classes.centred },
	          _react2.default.createElement(
	            _Grid2.default,
	            { container: true, spacing: 0 },
	            _react2.default.createElement(
	              _Grid2.default,
	              { item: true },
	              _react2.default.createElement(
	                _Typography2.default,
	                {
	                  variant: 'display1',
	                  className: classes.takeawayTitle
	                },
	                content.primary.takeaway_title.text
	              ),
	              _react2.default.createElement(
	                _Typography2.default,
	                { className: classes.takeawayText },
	                content.primary.takeaway_text.text
	              )
	            ),
	            _react2.default.createElement(
	              _Grid2.default,
	              { container: true, spacing: 32 },
	              content.items.map(function (item, index) {
	                return _react2.default.createElement(
	                  _Grid2.default,
	                  { key: index, item: true, xs: 12, sm: 4 },
	                  _react2.default.createElement(
	                    _Typography2.default,
	                    {
	                      variant: 'subheading',
	                      className: classes.takeawayDownloadTitle
	                    },
	                    item.download_title.text
	                  ),
	                  _react2.default.createElement(
	                    _Typography2.default,
	                    { className: classes.takeawayDownloadText },
	                    item.download_text.text
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      href: '' + item.download.url,
	                      target: '_new',
	                      style: { textDecoration: 'none' }
	                    },
	                    _react2.default.createElement(
	                      _Button2.default,
	                      {
	                        size: 'small',
	                        variant: 'outlined',
	                        className: classes.takeawayDownloadButton
	                      },
	                      'Download'
	                    )
	                  )
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(ThingContent);
	module.exports = exports['default'];

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    text: _extends({}, (0, _mixins.RichText)(theme)),
	    title: {
	      fontWeight: 800,
	      textTransform: 'uppercase'
	    },
	    thing: {
	      minHeight: '60vh',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center'
	    },
	    thingCandy: {
	      minHeight: '60vh',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center'
	    },
	    candyTitle: {
	      color: theme.palette.grey[600],
	      fontWeight: 800,
	      textTransform: 'uppercase',
	      marginBottom: theme.spacing.unit * 2
	    },
	    candyText: {
	      marginBottom: theme.spacing.unit * 5
	    },
	    thingTakeaway: {
	      background: '#047F8F',
	      minHeight: '60vh',
	      height: '100%',
	      display: 'flex',
	      alignItems: 'center'
	    },
	    takeawayTitle: {
	      color: 'rgba(255,255,255,1)',
	      fontWeight: 800,
	      textTransform: 'uppercase',
	      marginBottom: theme.spacing.unit * 2
	    },
	    takeawayText: {
	      color: 'rgba(255,255,255,1)',
	      marginBottom: theme.spacing.unit * 5
	    },
	    takeawayDownloadTitle: {
	      color: 'rgba(255,255,255,1)',
	      fontWeight: 400
	      // textTransform: 'uppercase'
	    },
	    takeawayDownloadText: {
	      color: 'rgba(255,255,255,1)'
	    },
	    takeawayDownloadButton: {
	      marginTop: theme.spacing.unit * 5,
	      '& span': {
	        color: 'rgba(255,255,255,1)'
	
	      }
	    }
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _thing = __webpack_require__(609);
	
	var _thing2 = _interopRequireDefault(_thing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Thing = function Thing(props) {
	  var metadata = (0, _mapper.mapMetaData)(props.data.thing);
	  var thing = (0, _mapper.mapThing)(props.data.thing);
	  return _react2.default.createElement(_thing2.default, { thing: thing, metadata: metadata });
	};
	
	exports.default = Thing;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-things-thing-js-9235e592042be9bae16b.js